export const RESET_FILTER_SELECTION = Symbol('RESET_FILTER_SELECTION')

export type FilterActions = 'click' | 'submit' | 'close' | 'reset'
export type FilterLabels = 'filter_modal' | 'quick_filters'
export type FilterSelectedValue =
  | boolean
  | [number, number]
  | number[]
  | string[]
export type FilterType = 'boolean' | 'range' | 'attribute'

export interface BaseFilterProperties {
  /**
   * unique string identifier fo the filter
   * e.g. categoryShopFilterSizes, color,...
   */
  readonly slug: string
}

export interface MainAttributeFilterSelectionEvent
  extends BaseFilterProperties {
  readonly filterType: 'attribute'

  /**
   * array of selected values, containing the selected value IDs
   */
  readonly selectedValue: number[]
}

export interface MainBooleanFilterSelectionEvent extends BaseFilterProperties {
  readonly filterType: 'boolean'

  /**
   * boolean flag indicating if the filter is active or not
   */
  readonly selectedValue: boolean
}

export interface MainRangeFilterSelectionEvent extends BaseFilterProperties {
  readonly filterType: 'range'

  /**
   * tuple containing the numeric min and max value for the range filter
   * [min, max]
   */
  readonly selectedValue: [number, number]
}

export type MainFilterSelectionEvent =
  | MainAttributeFilterSelectionEvent
  | MainBooleanFilterSelectionEvent
  | MainRangeFilterSelectionEvent

export interface QuickFilterSelectionEvent {
  /**
   * unique string identifier for the selected quick filter
   */
  readonly slug: 'none' | 'forYou' | 'new' | 'sale' | 'styleGroup'

  /**
   * selected filter styleGroup ID or null
   */
  readonly selectedValue: number | null
}

export type FilterSelection =
  | MainFilterSelectionEvent
  | QuickFilterSelectionEvent
